import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Menu,
  MenuItem,
  Typography,
  Stack,
  Chip,
  Divider,
  FormControlLabel,
  Checkbox,
  Popover,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  Autocomplete,
  ClickAwayListener,
  Slider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import moment from "moment";
import MuiAlert from "@mui/material/Alert";
import TuneIcon from "@mui/icons-material/Tune";
import axiosInstance from "../services/axiosInterceptors";
import apiEndPointsConfig from "../services/apiEndPoints";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import { useLocation, useNavigate } from "react-router-dom";
import KeyboardArrowDownTwoToneIcon from "@mui/icons-material/KeyboardArrowDownTwoTone";
import { palette, theme as colorTheme } from "../Convoze.theme";
import { jwtDecode } from "jwt-decode";

const today = moment();
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const primary = colorTheme("palette", "primary").value;
const primaryBg = colorTheme("palette", "primaryBg").value;
const positive = colorTheme("palette", "positive").value;
const positiveBg = colorTheme("palette", "positiveBg").value;
const neutral = colorTheme("palette", "neutral").value;
const neutralBg = colorTheme("palette", "neutralBg").value;
const negative = colorTheme("palette", "negative").value;
const negativeBg = colorTheme("palette", "negativeBg").value;

// const colorPalette = [
//   { bg: "#E0F7FA", text: "#00796B" },
//   { bg: "#FFF3E0", text: "#EF6C00" },
//   { bg: "#EDE7F6", text: "#5E35B1" },
//   { bg: "#F1F8E9", text: "#33691E" },
//   { bg: "#E1F5FE", text: "#0288D1" },
// ];

const colorPalette = [
  { bg: positiveBg, text: positive },
  { bg: neutralBg, text: neutral },
  { bg: primaryBg, text: primary },
  { bg: positiveBg, text: positive },
  { bg: primaryBg, text: primary },
];

let colorIndex = 0;

const getNextColor = () => {
  const color = colorPalette[colorIndex % colorPalette.length];
  colorIndex++;
  return color;
};

// duration  map addded for mapp into second
const durationMap = {
  "Upto 2 Mins": [0, 120],
  "Above 2 Mins": [121, 86400],
};

const CommonFilter = ({ storageName, setPayloadData, isFilter, defaultDateRange }) => {
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : "";

  const navigate = useNavigate();
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [calendarAnchor, setCalendarAnchor] = useState(null);
  const [dateRange, setDateRange] = useState([null, null]);
  const [expandedAccordion, setExpandedAccordion] = useState(false);
  const [campaginList, setCampaginList] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [agentList, setAgentList] = useState([]);
  const [branchManagerList, setBranchManagerList] = useState([]);
  const [dispositionList, setDispositionList] = useState();
  const [tempCallDuration, setTempCallDuration] = useState([0, 60]);
  // local state (keep near other filter states)
  const [tempCallScore, setTempCallScore] = useState([0, 100]);



  const [subDispositionList, setSubDispositionList] = useState();

  const location = useLocation();
  const open = Boolean(anchorEl);

  const [filterState, setFilterState] = useState(() => {
    const now = moment();
    const thisMonthStart = now.clone().startOf("month").format("YYYY-MM-DD");
    const thisMonthEnd = now.clone().endOf("month").format("YYYY-MM-DD");

    const buildThisMonthDefault = () => ({
      filters: {
        startDate: thisMonthStart,
        endDate: thisMonthEnd,
        sentiment: [],
        status: "",
        agents: [],
        branchManagers: [],
        campaigns: [],
        callInteraction: "",
        callCompliance: "",
        callDuration: [],
        disposition: [],
        subDisposition: [],
        callScore: [],
        conversionStatus: [],
        categoryDistribution: [],
      },
      appliedFilters: [{ key: "date", label: "This Month", startDate: thisMonthStart, endDate: thisMonthEnd }],
      frequentKeywords: "",
    });

    const stored = localStorage.getItem(storageName);
    if (stored) {
      try {
        const parsed = JSON.parse(atob(stored));
        const storedEnd = parsed?.filters?.endDate;
        // When defaultDateRange="month", reset empty dates or stale dates from previous months
        if (defaultDateRange === "month" && (!storedEnd || storedEnd < thisMonthStart)) {
          return buildThisMonthDefault();
        }
        return parsed;
      } catch (err) {
        console.error("Decoding error:", err);
      }
    }
    if (defaultDateRange === "month") {
      return buildThisMonthDefault();
    }
    return {
      filters: {
        startDate: "",
        endDate: "",
        sentiment: [],
        status: "",
        agents: [],
        branchManagers: [],
        campaigns: [],
        callInteraction: "",
        callCompliance: "",
        callDuration: [],
        disposition: [],
        subDisposition: [],
        callScore: [],
        conversionStatus: [],
        categoryDistribution: [],
      },
      appliedFilters: [],
      frequentKeywords: "",
    };
  });

  useEffect(() => {
    const mapped = {
      ...filterState,
      filters: {
        ...filterState.filters,
        callDuration: filterState.filters.callDuration.flatMap(
          (key) => durationMap[key] || []
        ),
      },
    };
    localStorage.setItem(storageName, btoa(JSON.stringify(filterState)));
    setPayloadData(mapped);
  }, [filterState, storageName]);

  // sync with applied filters
  useEffect(() => {
    if (filterState?.filters?.callScore?.length) {
      setTempCallScore(filterState.filters.callScore);
    } else {
      setTempCallScore([0, 100]);
    }
  }, [filterState?.filters?.callScore]);


  //agent,campaign,dispositions
  useEffect(() => {
    if (isFilter?.filter) {
      fetchAgentCampaignDetails();
    }
  }, []);

  const fetchAgentCampaignDetails = async () => {
    try {
      const isKiwiCompany = decodedToken?.companyId === "6a6b4ce723abe63bde91abf2";
      const endpoint = isKiwiCompany
        ? apiEndPointsConfig?.kiwiFilterDetails
        : apiEndPointsConfig?.agentCampaignList;
      const res = await axiosInstance.get(
        `${endpoint}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setAgentList(res?.data?.data?.agentName);
      setCampaginList(res?.data?.data?.campaignName);
      setDispositionList(res?.data?.data?.dispositions);
      setSubDispositionList(res?.data?.data?.subDispositions);
      setBranchManagerList(res?.data?.data?.branchManagerName);
    } catch (error) {
      console.error("Error fetching audio details", error);
    }
  };

  //dahsboard drilldown
  useEffect(() => {
    if (!location.state) return;
    if (!dispositionList && !subDispositionList) return;

    if (location.state?.source === "dashboard-disposition") {
      const selectedDisposition = location?.state?.label;
      const matchedItem = dispositionList?.find(
        (item) => item.toLowerCase() === selectedDisposition?.toLowerCase()
      );

      if (matchedItem) {
        setFilterState((prev) => {
          const existing = prev?.filters?.disposition || [];
          if (
            existing.some(
              (item) => item.toLowerCase() === matchedItem.toLowerCase()
            )
          ) {
            return prev;
          }
          return {
            ...prev,
            filters: {
              ...prev.filters,
              disposition: [...existing, matchedItem],
            },
          };
        });
      }
    } else if (location?.state?.source === "dashboard-subDisposition") {
      const selectedSubDisposition = location?.state?.label;
      const matchedItem = subDispositionList?.find(
        (item) => item.toLowerCase() === selectedSubDisposition?.toLowerCase()
      );

      if (matchedItem) {
        setFilterState((prev) => {
          const existing = prev.filters.subDisposition || [];
          if (
            existing.some(
              (item) => item.toLowerCase() === matchedItem.toLowerCase()
            )
          ) {
            return prev;
          }
          return {
            ...prev,
            filters: {
              ...prev.filters,
              subDisposition: [...existing, matchedItem],
            },
          };
        });
      }
    } else if (location.state?.source === "dashboard-frequency") {
      setFilterState((prev) => ({
        ...prev,
        frequentKeywords: location.state.label,
      }));
    }

    navigate(location.pathname, { replace: true });
  }, [location?.state, dispositionList, subDispositionList]);

  // Add this useEffect in CommonFilter component to handle incoming filters from dashboard

  useEffect(() => {
    if (!location.state?.filters) return;

    console.log("🔍 Received filters from navigation:", location.state.filters);

    // Merge incoming filters with existing state
    setFilterState((prev) => {
      const incomingFilters = location.state.filters;

      return {
        ...prev,
        filters: {
          ...prev.filters,
          // Merge each filter type
          startDate: incomingFilters.startDate || prev.filters.startDate,
          endDate: incomingFilters.endDate || prev.filters.endDate,
          sentiment: incomingFilters.sentiment || prev.filters.sentiment,
          status: incomingFilters.status ?? prev.filters.status,
          agents: incomingFilters.agents || prev.filters.agents,
          campaigns: incomingFilters.campaigns || prev.filters.campaigns,
          disposition: incomingFilters.disposition || prev.filters.disposition,
          subDisposition: incomingFilters.subDisposition || prev.filters.subDisposition,
          callInteraction: incomingFilters.callDirection || prev.filters.callInteraction,
          callDuration: incomingFilters.callDurationText || prev.filters.callDuration,
          conversionStatus: incomingFilters.conversionStatus || prev.filters.conversionStatus,
          categoryDistribution: incomingFilters.categoryDistribution || prev.filters.categoryDistribution,
        },
      };
    });

    // Clear navigation state
    navigate(location.pathname, { replace: true });
  }, [location.state]);

  useEffect(() => {
    localStorage.setItem(storageName, btoa(JSON.stringify(filterState)));
    setPayloadData(filterState);
  }, [filterState, storageName]);

  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const updateFilterArray = (field, newValue) => {
    setFilterState((prev) => {
      const currentValues = prev.filters[field] || [];

      const updatedValues = Array.isArray(newValue)
        ? newValue
        : currentValues.includes(newValue)
          ? currentValues.filter((v) => v !== newValue)
          : [...currentValues, newValue];
      return {
        ...prev,
        filters: {
          ...prev.filters,
          [field]: updatedValues,
        },
      };
    });
  };
  const handleMenuClick = (e) => setMenuAnchor(e.currentTarget);
  const handleMenuClose = () => setMenuAnchor(null);
  const applyFilter = (key, label, startDate, endDate) => {
    const color = getNextColor();
    setFilterState((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        startDate,
        endDate,
      },
      appliedFilters: [
        ...prev.appliedFilters.filter((f) => f.key !== key),
        { key, label, startDate, endDate, color },
      ],
    }));
  };
  useEffect(() => {
    if (filterState?.filters?.callDuration?.length) {
      setTempCallDuration(filterState.filters.callDuration);
    } else {
      setTempCallDuration([0, 60]);
    }
  }, [filterState?.filters?.callDuration]);

  const handleQuickSelect = (option) => {
    const now = moment();
    let startDate, endDate, label;

    switch (option) {
      case "all":
        startDate = now.clone().startOf("year");
        endDate = now;
        label = "All";
        break;
      case "today":
        startDate = endDate = now;
        label = "Today";
        break;
      case "yesterday":
        startDate = endDate = now.clone().subtract(1, "day");
        label = "Yesterday";
        break;
      case "week":
        startDate = now.clone().startOf("week");
        endDate = now.clone().endOf("week");
        label = "This Week";
        break;
      case "lastWeek":
        startDate = now.clone().subtract(1, "week").startOf("week");
        endDate = now.clone().subtract(1, "week").endOf("week");
        label = "Last Week";
        break;
      case "month":
        startDate = now.clone().startOf("month");
        endDate = now.clone().endOf("month");
        label = "This Month";
        break;
      case "lastMonth":
        startDate = now.clone().subtract(1, "month").startOf("month");
        endDate = now.clone().subtract(1, "month").endOf("month");
        label = "Last Month";
        break;
      default:
        return;
    }

    applyFilter(
      "date",
      label,
      startDate.format("YYYY-MM-DD"),
      endDate.format("YYYY-MM-DD")
    );
    handleMenuClose();
  };
  const handleCustomClick = (e) => {
    setCalendarAnchor(e.currentTarget);
    setDateRange([null, null]);
    handleMenuClose();
  };
  const handleCalendarChange = (range) => {
    if (range[0] && range[1]) {
      const start = moment(range[0]);
      const end = moment(range[1]);
      const label = `${start.format("MMM D")} - ${end.format("MMM D")}`;

      applyFilter(
        "date",
        label,
        start.format("YYYY-MM-DD"),
        end.format("YYYY-MM-DD")
      );
      setCalendarAnchor(null);
    }
  };
  const handleRemoveFilter = (key) => {
    if (key === "date") {
      setFilterState((prev) => ({
        ...prev,
        filters: {
          ...prev.filters,
          startDate: moment().format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
        },
        appliedFilters: [
          {
            key: "date",
            label: "Today",
            startDate: moment().format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
          },
        ],
      }));
    } else {
      setFilterState((prev) => ({
        ...prev,
        filters: {
          ...prev.filters,
          [key]: Array.isArray(prev.filters[key]) ? [] : "",
        },
        appliedFilters: prev.appliedFilters.filter((f) => f.key !== key),
      }));
    }
  };
  const handleRemoveExtraFilter = (key) => {
    setFilterState((prev) => ({
      ...prev,
      frequentKeywords: "",
    }));
  };
  const isAnyFilterApplied =
    filterState?.filters?.sentiment?.length > 0 ||
    Boolean(filterState?.filters?.status) ||
    filterState?.filters?.agents?.length > 0 ||
    filterState?.filters?.branchManagers?.length > 0 ||
    filterState?.filters?.campaigns?.length > 0 ||
    filterState?.filters?.callInteraction !== "" ||
    filterState?.filters?.callCompliance !== "" ||
    filterState?.filters?.callDuration?.length > 0 ||
    filterState?.filters?.disposition?.length > 0 ||
    filterState?.filters?.subDisposition?.length > 0 ||
    filterState?.filters?.callScore?.length > 0 ||
    filterState?.filters?.conversionStatus?.length > 0 ||
    filterState?.filters?.categoryDistribution?.length > 0;

  const isAnyDashboardFilterApplied = filterState?.frequentKeywords !== "";
  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        justifyContent: "flex-end",
        gap: 2,
      }}
    >
      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <Stack direction="row" spacing={1} sx={{}}>
          {filterState?.frequentKeywords && (
            <Chip
              label={filterState?.frequentKeywords}
              onDelete={() =>
                handleRemoveExtraFilter(filterState?.frequentKeywords)
              }
              sx={{
                borderRadius: "12px",
                textTransform: "none",
                border: `2px solid  ${primaryBg}`,
                color: "#1E293B",
                bgcolor: "#E6F0FF",
                boxShadow: "0px 1px 1px 0px #D2D2D2",
                fontWeight: 500,
                fontSize: "14px",
                transition: "background-color 0.2s, box-shadow 0.2s",
                "&:hover": {
                  backgroundColor: "#EEF2FF",
                  boxShadow: "0px 1px 4px rgba(0,0,0,0.1)",
                },
                "&:active": {
                  boxShadow: "inset 0 2px 4px rgba(0,0,0,0.2)",
                  backgroundColor: "#E0E7FF",
                },
              }}
            />
          )}
        </Stack>
        {/* <Stack direction="row" spacing={1} sx={{}}>
          {filterState?.appliedFilters?.map((filter) => {
            return (
              <>
                {filter?.label == "Today" ? (
                  <Chip
                    key={filter.key + filter.label}
                    label={filter.label}
                    sx={{
                      borderRadius: "12px",
                      textTransform: "none",
                      border: "2px solid #91b5f3",
                      color: "#1E293B",
                      bgcolor: "#E6F0FF",
                      boxShadow: "0px 1px 1px 0px #D2D2D2",
                      fontWeight: 500,
                      fontSize: "14px",
                      transition: "background-color 0.2s, box-shadow 0.2s",
                      "&:hover": {
                        backgroundColor: "#EEF2FF",
                        boxShadow: "0px 1px 4px rgba(0,0,0,0.1)",
                      },
                      "&:active": {
                        boxShadow: "inset 0 2px 4px rgba(0,0,0,0.2)",
                        backgroundColor: "#E0E7FF",
                      },
                    }}
                  />
                ) : (
                  <Chip
                    key={filter.key + filter.label}
                    label={filter.label}
                    onDelete={() => handleRemoveFilter(filter.key)}
                    sx={{
                      borderRadius: "12px",
                      textTransform: "none",
                      border: "2px solid #91b5f3",
                      color: "#1E293B",
                      bgcolor: "#E6F0FF",
                      boxShadow: "0px 1px 1px 0px #D2D2D2",
                      fontWeight: 500,
                      fontSize: "14px",
                      transition: "background-color 0.2s, box-shadow 0.2s",
                      "&:hover": {
                        backgroundColor: "#EEF2FF",
                        boxShadow: "0px 1px 4px rgba(0,0,0,0.1)",
                      },
                      "&:active": {
                        boxShadow: "inset 0 2px 4px rgba(0,0,0,0.2)",
                        backgroundColor: "#E0E7FF",
                      },
                    }}
                  />
                )}
              </>
            );
          })}
        </Stack> */}

        {/* Date Filter */}
        <Button
          variant="outlined"
          disableRipple={false}
          focusRipple
          onClick={handleMenuClick}
          startIcon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-calendar w-4 h-4 mr-2 text-muted-foreground"
              data-lov-id="src/components/dashboard/DashboardHeader.tsx:21:12"
              data-lov-name="CalendarIcon"
              data-component-path="src/components/dashboard/DashboardHeader.tsx"
              data-component-line="21"
              data-component-file="DashboardHeader.tsx"
              data-component-name="CalendarIcon"
              data-component-content="%7B%22className%22%3A%22w-4%20h-4%20mr-2%20text-muted-foreground%22%7D"
            >
              <path d="M8 2v4"></path>
              <path d="M16 2v4"></path>
              <rect width="18" height="18" x="3" y="4" rx="2"></rect>
              <path d="M3 10h18"></path>
            </svg>
          }
          endIcon={<KeyboardArrowDownTwoToneIcon />}
          sx={{
            borderRadius: "12px",
            textTransform: "none",
            border:
              filterState?.appliedFilters?.length > 0
                ? `2px solid ${primaryBg}`
                : "1px solid #E0E0E0",
            color: "#1E293B",
            p: "5px 20px",
            bgcolor:
              filterState?.appliedFilters?.length > 0 ? "#E6F0FF" : "#fff",
            boxShadow: "0px 1px 1px 0px #D2D2D2",
            transition: "background-color 0.2s, box-shadow 0.2s",
            "&:hover": {
              backgroundColor: "#EEF2FF",
              boxShadow: "0px 1px 4px rgba(0,0,0,0.1)",
            },
            "&:active": {
              boxShadow: "inset 0 2px 4px rgba(0,0,0,0.2)",
              backgroundColor: "#E0E7FF",
            },
            letterSpacing: "0px",
          }}
        >
          {filterState?.appliedFilters?.length > 0
            ? filterState?.appliedFilters?.map((filter) => {
              return filter?.label;
            })
            : "Today"}
        </Button>

        <Menu
          anchorEl={menuAnchor}
          open={Boolean(menuAnchor)}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          sx={{ mt: 0.5, borderRadius: 2 }}
        >
          <MenuItem
            sx={{ p: 0, px: 2 }}
            onClick={() => handleQuickSelect("all")}
          >
            All
          </MenuItem>
          <Divider />
          <MenuItem
            sx={{ p: 0, px: 2 }}
            onClick={() => handleQuickSelect("today")}
          >
            Today
          </MenuItem>
          <Divider />
          <MenuItem
            sx={{ p: 0, px: 2 }}
            onClick={() => handleQuickSelect("yesterday")}
          >
            Yesterday
          </MenuItem>
          <Divider />
          <MenuItem
            sx={{ p: 0, px: 2 }}
            onClick={() => handleQuickSelect("week")}
          >
            This Week
          </MenuItem>
          <Divider />
          <MenuItem
            sx={{ p: 0, px: 2 }}
            onClick={() => handleQuickSelect("lastWeek")}
          >
            Last Week
          </MenuItem>
          <Divider />
          <MenuItem
            sx={{ p: 0, px: 2 }}
            onClick={() => handleQuickSelect("month")}
          >
            This Month
          </MenuItem>
          <Divider />
          <MenuItem
            sx={{ p: 0, px: 2 }}
            onClick={() => handleQuickSelect("lastMonth")}
          >
            Last Month
          </MenuItem>
          <Divider />
          <MenuItem sx={{ p: 0, px: 2 }} onClick={handleCustomClick}>
            Custom Date Range
          </MenuItem>
        </Menu>

        {calendarAnchor && (
          <ClickAwayListener onClickAway={() => setCalendarAnchor(null)}>
            <Box
              sx={{
                position: "absolute",
                top: "45px",
                right: "50px",
                zIndex: 99,
                boxShadow: 3,
                borderRadius: 2,
                overflow: "hidden",
              }}
            >
              <Calendar
                selectRange
                onChange={handleCalendarChange}
                value={dateRange}
                maxDate={new Date()}
              />
            </Box>
          </ClickAwayListener>
        )}

        {/* Filter */}
        {isFilter?.filter && (
          <Button
            variant="outlined"
            disableRipple={false}
            focusRipple
            onClick={handleFilterClick}
            startIcon={<TuneIcon />}
            sx={{
              borderRadius: "12px",
              textTransform: "none",
              border: isAnyFilterApplied
                ? `2px solid ${primaryBg}`
                : "1px solid #E0E0E0",
              color: "#1E293B",
              p: "5px 40px",
              bgcolor: isAnyFilterApplied ? "#E6F0FF" : "#fff",
              boxShadow: "0px 1px 1px 0px #D2D2D2",
              transition: "background-color 0.2s, box-shadow 0.2s",
              "&:hover": {
                backgroundColor: "#EEF2FF",
                boxShadow: "0px 1px 4px rgba(0,0,0,0.1)",
              },
              "&:active": {
                boxShadow: "inset 0 2px 4px rgba(0,0,0,0.2)",
                backgroundColor: "#E0E7FF",
              },
            }}
          >
            Filter
          </Button>
        )}

        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            sx: {
              width: 220,
              mt: 0.5,
              borderRadius: 2,
              overflow: "hidden",
            },
          }}
        >
          {/* Sentiment */}
          <Accordion
            disableGutters
            expanded={expandedAccordion === "sentiment"}
            onChange={() =>
              setExpandedAccordion(
                expandedAccordion === "sentiment" ? false : "sentiment"
              )
            }
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                border:
                  filterState?.filters?.sentiment?.length > 0
                    ? `2px solid ${primaryBg}`
                    : "1px solid transparent",
                backgroundColor:
                  filterState?.filters?.sentiment?.length > 0
                    ? "#E6F0FF"
                    : "inherit",
                borderRadius:
                  filterState?.filters?.sentiment?.length > 0 ? 2 : 0,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                }}
              >
                <Typography>Sentiment</Typography>
                {filterState?.filters?.sentiment?.length > 0 && (
                  <Box
                    sx={{
                      // backgroundColor: "#0052CC",
                      backgroundColor: primary,
                      color: "white",
                      fontSize: 10,
                      fontWeight: "bold",
                      borderRadius: "12px",
                      px: 0.5,
                      py: 0.3,
                      minWidth: 15,
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {filterState?.filters?.sentiment?.length}
                  </Box>
                )}
              </Box>
            </AccordionSummary>
            <Divider />
            <AccordionDetails>
              {["Positive", "Negative", "Neutral"].map((item) => (
                <FormControlLabel
                  key={item}
                  control={
                    <Checkbox
                      checked={filterState?.filters?.sentiment?.includes(item)}
                      onChange={() => updateFilterArray("sentiment", item)}
                      sx={{
                        // color: "#6366F1",
                        color: primary,
                        "&.Mui-checked": {
                          // color: "#6366F1",
                          color: primary,
                        },
                      }}
                    />
                  }
                  label={item}
                />
              ))}
            </AccordionDetails>
          </Accordion>

          {/* Agent */}
          <Accordion
            disableGutters
            expanded={expandedAccordion === "agent"}
            onChange={() =>
              setExpandedAccordion(
                expandedAccordion === "agent" ? false : "agent"
              )
            }
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                border:
                  filterState?.filters?.agents?.length > 0
                    ? `2px solid ${primaryBg}`
                    : "1px solid transparent",
                backgroundColor:
                  filterState?.filters?.agents?.length > 0
                    ? "#E6F0FF"
                    : "inherit",
                borderRadius: filterState?.filters?.agents?.length > 0 ? 2 : 0,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                }}
              >
                <Typography>Agents</Typography>

                {filterState?.filters?.agents?.length > 0 && (
                  <Box
                    sx={{
                      // backgroundColor: "#0052CC",
                      backgroundColor: primary,
                      color: "white",
                      fontSize: 10,
                      fontWeight: "bold",
                      borderRadius: "12px",
                      px: 0.5,
                      py: 0.3,
                      minWidth: 15,
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {filterState?.filters?.agents?.length}
                  </Box>
                )}
              </Box>
            </AccordionSummary>
            <Divider />
            <AccordionDetails>
              <Autocomplete
                multiple
                disableCloseOnSelect
                options={agentList || []}
                value={filterState?.filters?.agents}
                onChange={(e, newValue) =>
                  updateFilterArray("agents", newValue)
                }
                getOptionLabel={(option) => option}
                isOptionEqualToValue={(option, value) => option === value}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      style={{ marginRight: 8 }}
                      checked={selected}
                      sx={{
                        // color: "#6366F1",
                        color: primary,
                        "&.Mui-checked": { color: primary },
                      }}
                    />
                    {option}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Search Agents"
                    placeholder="Search agents"
                    sx={{
                      "& label.Mui-focused": { color: primary },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: "#ccc" },
                        "&:hover fieldset": { borderColor: primary },
                        "&.Mui-focused fieldset": {
                          borderColor: primary,
                        },
                      },
                    }}
                  />
                )}
              />
            </AccordionDetails>
          </Accordion>

          {/* Branch Manager */}
          {decodedToken?.userRole !== "BranchManager" && (
            <Accordion
              disableGutters
              expanded={expandedAccordion === "branchManagers"}
              onChange={() =>
                setExpandedAccordion(
                  expandedAccordion === "branchManagers" ? false : "branchManagers"
                )
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  border:
                    filterState?.filters?.branchManagers?.length > 0
                      ? `2px solid ${primaryBg}`
                      : "1px solid transparent",
                  backgroundColor:
                    filterState?.filters?.branchManagers?.length > 0
                      ? "#E6F0FF"
                      : "inherit",
                  borderRadius:
                    filterState?.filters?.branchManagers?.length > 0 ? 2 : 0,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 2,
                  }}
                >
                  <Typography>Branch Manager</Typography>

                  {filterState?.filters?.branchManagers?.length > 0 && (
                    <Box
                      sx={{
                        backgroundColor: primary,
                        color: "white",
                        fontSize: 10,
                        fontWeight: "bold",
                        borderRadius: "12px",
                        px: 0.5,
                        py: 0.3,
                        minWidth: 15,
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {filterState?.filters?.branchManagers?.length}
                    </Box>
                  )}
                </Box>
              </AccordionSummary>
              <Divider />
              <AccordionDetails>
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  options={branchManagerList || []}
                  value={filterState?.filters?.branchManagers}
                  onChange={(e, newValue) =>
                    updateFilterArray("branchManagers", newValue)
                  }
                  getOptionLabel={(option) => option}
                  isOptionEqualToValue={(option, value) => option === value}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        style={{ marginRight: 8 }}
                        checked={selected}
                        sx={{
                          color: primary,
                          "&.Mui-checked": { color: primary },
                        }}
                      />
                      {option}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Search Branch Manager"
                      placeholder="Search branch manager"
                      sx={{
                        "& label.Mui-focused": { color: primary },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": { borderColor: "#ccc" },
                          "&:hover fieldset": { borderColor: primary },
                          "&.Mui-focused fieldset": {
                            borderColor: primary,
                          },
                        },
                      }}
                    />
                  )}
                />
              </AccordionDetails>
            </Accordion>
          )}

          {decodedToken?.companyId === "67e560a6ae2e0d3f96b5eb08" && (
            <>
              {/* Conversation Status */}
              <Accordion
                disableGutters
                expanded={expandedAccordion === "conversionStatus"}
                onChange={() =>
                  setExpandedAccordion(
                    expandedAccordion === "conversionStatus" ? false : "conversionStatus"
                  )
                }
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    border:
                      filterState?.filters?.conversionStatus?.length > 0
                        ? `2px solid ${primaryBg}`
                        : "1px solid transparent",
                    backgroundColor:
                      filterState?.filters?.conversionStatus?.length > 0
                        ? "#E6F0FF"
                        : "inherit",
                    borderRadius:
                      filterState?.filters?.conversionStatus?.length > 0 ? 2 : 0,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 2,
                    }}
                  >
                    <Typography>Conversion Status</Typography>
                    {filterState?.filters?.conversionStatus?.length > 0 && (
                      <Box
                        sx={{
                          backgroundColor: primary,
                          color: "white",
                          fontSize: 10,
                          fontWeight: "bold",
                          borderRadius: "12px",
                          px: 0.5,
                          py: 0.3,
                          minWidth: 15,
                          textAlign: "center",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {filterState?.filters?.conversionStatus?.length}
                      </Box>
                    )}
                  </Box>
                </AccordionSummary>
                <Divider />
                <AccordionDetails>
                  {["Converted", "Follow-up Required", "Not Converted"].map((item) => (
                    <FormControlLabel
                      key={item}
                      control={
                        <Checkbox
                          checked={filterState?.filters?.conversionStatus?.includes(item)}
                          onChange={() => updateFilterArray("conversionStatus", item)}
                          sx={{
                            color: primary,
                            "&.Mui-checked": {
                              color: primary,
                            },
                          }}
                        />
                      }
                      label={item}
                    />
                  ))}
                </AccordionDetails>
              </Accordion>

              {/* Category Distribution */}
              <Accordion
                disableGutters
                expanded={expandedAccordion === "categoryDistribution"}
                onChange={() =>
                  setExpandedAccordion(
                    expandedAccordion === "categoryDistribution" ? false : "categoryDistribution"
                  )
                }
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    border:
                      filterState?.filters?.categoryDistribution?.length > 0
                        ? `2px solid ${primaryBg}`
                        : "1px solid transparent",
                    backgroundColor:
                      filterState?.filters?.categoryDistribution?.length > 0
                        ? "#E6F0FF"
                        : "inherit",
                    borderRadius:
                      filterState?.filters?.categoryDistribution?.length > 0 ? 2 : 0,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 2,
                    }}
                  >
                    <Typography>Category Distribution</Typography>
                    {filterState?.filters?.categoryDistribution?.length > 0 && (
                      <Box
                        sx={{
                          backgroundColor: primary,
                          color: "white",
                          fontSize: 10,
                          fontWeight: "bold",
                          borderRadius: "12px",
                          px: 0.5,
                          py: 0.3,
                          minWidth: 15,
                          textAlign: "center",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {filterState?.filters?.categoryDistribution?.length}
                      </Box>
                    )}
                  </Box>
                </AccordionSummary>
                <Divider />
                <AccordionDetails>
                  {["Agent", "Process", "Technology", "Customer"].map((item) => (
                    <FormControlLabel
                      key={item}
                      control={
                        <Checkbox
                          checked={filterState?.filters?.categoryDistribution?.includes(item)}
                          onChange={() => updateFilterArray("categoryDistribution", item)}
                          sx={{
                            color: primary,
                            "&.Mui-checked": {
                              color: primary,
                            },
                          }}
                        />
                      }
                      label={item}
                    />
                  ))}
                </AccordionDetails>
              </Accordion>
            </>)}
          {/* Campaign */}
          <Accordion
            disableGutters
            expanded={expandedAccordion === "campaign"}
            onChange={() =>
              setExpandedAccordion(
                expandedAccordion === "campaign" ? false : "campaign"
              )
            }
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                border:
                  filterState?.filters?.campaigns?.length > 0
                    ? `2px solid ${primaryBg}`
                    : "1px solid transparent",
                backgroundColor:
                  filterState?.filters?.campaigns?.length > 0
                    ? "#E6F0FF"
                    : "inherit",
                borderRadius:
                  filterState?.filters?.campaigns?.length > 0 ? 2 : 0,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                }}
              >
                <Typography>Campaigns</Typography>
                {filterState?.filters?.campaigns?.length > 0 && (
                  <Box
                    sx={{
                      // backgroundColor: "#0052CC",
                      backgroundColor: primary,
                      color: "white",
                      fontSize: 12,
                      fontWeight: "bold",
                      borderRadius: "12px",
                      px: 0.5,
                      py: 0.3,
                      minWidth: 15,
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {filterState?.filters?.campaigns?.length}
                  </Box>
                )}
              </Box>
            </AccordionSummary>
            <Divider />
            <AccordionDetails>
              <Autocomplete
                multiple
                disableCloseOnSelect
                options={campaginList || []}
                value={filterState?.filters?.campaigns}
                onChange={(e, newValue) =>
                  updateFilterArray("campaigns", newValue)
                }
                getOptionLabel={(option) => option}
                isOptionEqualToValue={(option, value) => option === value}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      style={{ marginRight: 8 }}
                      checked={selected}
                      sx={{
                        // color: "#6366F1",
                        color: primary,
                        "&.Mui-checked": { color: primary },
                      }}
                    />
                    {option}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Search Campaigns"
                    placeholder="Search"
                    sx={{
                      "& label.Mui-focused": { color: primary },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: "#ccc" },
                        "&:hover fieldset": { borderColor: primary },
                        "&.Mui-focused fieldset": {
                          borderColor: primary,
                        },
                      },
                    }}
                  />
                )}
              />
            </AccordionDetails>
          </Accordion>

          {/* disposition */}
          <Accordion
            disableGutters
            expanded={expandedAccordion === "disposition"}
            onChange={() =>
              setExpandedAccordion(
                expandedAccordion === "disposition" ? false : "disposition"
              )
            }
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                border:
                  filterState?.filters?.disposition?.length > 0
                    ? `2px solid ${primaryBg}`
                    : "1px solid transparent",
                backgroundColor:
                  filterState?.filters?.disposition?.length > 0
                    ? "#E6F0FF"
                    : "inherit",
                borderRadius:
                  filterState?.filters?.disposition?.length > 0 ? 2 : 0,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                }}
              >
                <Typography>Disposition</Typography>
                {filterState?.filters?.disposition?.length > 0 && (
                  <Box
                    sx={{
                      backgroundColor: primary,
                      color: "white",
                      fontSize: 12,
                      fontWeight: "bold",
                      borderRadius: "12px",
                      px: 0.5,
                      py: 0.3,
                      minWidth: 15,
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {filterState?.filters?.disposition?.length}
                  </Box>
                )}
              </Box>
            </AccordionSummary>
            <Divider />
            <AccordionDetails>
              <Autocomplete
                multiple
                disableCloseOnSelect
                options={dispositionList || []}
                value={filterState?.filters?.disposition}
                onChange={(e, newValue) =>
                  updateFilterArray("disposition", newValue)
                }
                getOptionLabel={(option) => option}
                isOptionEqualToValue={(option, value) => option === value}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      style={{ marginRight: 8 }}
                      checked={selected}
                      sx={{
                        color: primary,
                        "&.Mui-checked": { color: primary },
                      }}
                    />
                    {option}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Search Disposition"
                    placeholder="Search"
                    sx={{
                      "& label.Mui-focused": { color: primary },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: "#ccc" },
                        "&:hover fieldset": { borderColor: primary },
                        "&.Mui-focused fieldset": {
                          borderColor: primary,
                        },
                      },
                    }}
                  />
                )}
              />
            </AccordionDetails>
          </Accordion>

          {/*sub disposition */}
          <Accordion
            disableGutters
            expanded={expandedAccordion === "subDisposition"}
            onChange={() =>
              setExpandedAccordion(
                expandedAccordion === "subDisposition"
                  ? false
                  : "subDisposition"
              )
            }
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                border:
                  filterState?.filters?.subDisposition?.length > 0
                    ? `2px solid ${primaryBg}`
                    : "1px solid transparent",
                backgroundColor:
                  filterState?.filters?.subDisposition?.length > 0
                    ? "#E6F0FF"
                    : "inherit",
                borderRadius:
                  filterState?.filters?.subDisposition?.length > 0 ? 2 : 0,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                }}
              >
                <Typography>Sub Disposition</Typography>
                {filterState?.filters?.subDisposition?.length > 0 && (
                  <Box
                    sx={{
                      backgroundColor: primary,
                      color: "white",
                      fontSize: 12,
                      fontWeight: "bold",
                      borderRadius: "12px",
                      px: 0.5,
                      py: 0.3,
                      minWidth: 15,
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {filterState?.filters?.subDisposition?.length}
                  </Box>
                )}
              </Box>
            </AccordionSummary>
            <Divider />

            <AccordionDetails>
              <Autocomplete
                multiple
                disableCloseOnSelect
                options={subDispositionList || []}
                value={filterState?.filters?.subDisposition}
                onChange={(e, newValue) =>
                  updateFilterArray("subDisposition", newValue)
                }
                getOptionLabel={(option) => option}
                isOptionEqualToValue={(option, value) => option === value}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      style={{ marginRight: 8 }}
                      checked={selected}
                      sx={{
                        color: primary,
                        "&.Mui-checked": { color: primary },
                      }}
                    />
                    {option}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Search Sub Disposition"
                    placeholder="Search"
                    sx={{
                      "& label.Mui-focused": { color: primary },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: "#ccc" },
                        "&:hover fieldset": { borderColor: primary },
                        "&.Mui-focused fieldset": {
                          borderColor: primary,
                        },
                      },
                    }}
                  />
                )}
              />
            </AccordionDetails>
          </Accordion>

          {/* Call Compliance // add new filter option */}
          {/* <Accordion
            disableGutters
            expanded={expandedAccordion === 'callCompliance'}
            onChange={() =>
              setExpandedAccordion(
                expandedAccordion === 'callCompliance' ? false : 'callCompliance'
              )
            }
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                <Typography>Call Compliance</Typography>
              </Box>
            </AccordionSummary>
            <Divider />

            <AccordionDetails>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                {['Pass', 'Fail'].map((option) => (
                  <FormControlLabel
                    key={option}
                    control={
                      <Checkbox
                        icon={<RadioButtonUncheckedIcon />}
                        checkedIcon={<RadioButtonCheckedIcon />}
                        sx={{ color: primary, '&.Mui-checked': { color: primary } }}
                      />
                    }
                    label={option}
                  />
                ))}
              </Box>
            </AccordionDetails>
          </Accordion> */}

          {/* Call Interaction */}
          <Accordion
            disableGutters
            expanded={expandedAccordion === "callInteraction"}
            onChange={() =>
              setExpandedAccordion(
                expandedAccordion === "callInteraction"
                  ? false
                  : "callInteraction"
              )
            }
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                border: filterState?.filters?.callInteraction
                  ? `2px solid ${primaryBg}`
                  : "1px solid transparent",
                backgroundColor: filterState?.filters?.callInteraction
                  ? "#E6F0FF"
                  : "inherit",
                borderRadius: filterState?.filters?.callInteraction ? 2 : 0,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                }}
              >
                <Typography>Call Direction </Typography>
                {filterState?.filters?.callInteraction && (
                  <Box
                    sx={{
                      backgroundColor: primary,
                      color: "white",
                      fontSize: 12,
                      fontWeight: "bold",
                      borderRadius: "12px",
                      px: 0.5,
                      py: 0.3,
                      minWidth: 15,
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {1}
                  </Box>
                )}
              </Box>
            </AccordionSummary>
            <Divider />
            {/* <AccordionDetails>
              <RadioGroup
                value={filters?.callInteraction}
                onChange={handleRadioChange("callInteraction")}
              >
                <FormControlLabel
                  value="Inbound"
                  control={
                    <Radio
                      sx={{
                        color: "#6366F1",
                        "&.Mui-checked": {
                          color: "#6366F1",
                        },
                      }}
                    />
                  }
                  label="Inbound"
                />
                <FormControlLabel
                  value="Outbound"
                  control={
                    <Radio
                      sx={{
                        color: "#6366F1",
                        "&.Mui-checked": {
                          color: "#6366F1",
                        },
                      }}
                    />
                  }
                  label="Outbound"
                />
              </RadioGroup>
            </AccordionDetails> */}
            <AccordionDetails>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                {["Inbound", "Outbound"].map((option) => (
                  <FormControlLabel
                    key={option}
                    control={
                      <Checkbox
                        checked={
                          filterState?.filters?.callInteraction === option
                        }
                        onChange={() => {
                          setFilterState((prev) => ({
                            ...prev,
                            filters: {
                              ...prev.filters,
                              callInteraction:
                                prev.filters.callInteraction === option
                                  ? ""
                                  : option,
                            },
                          }));
                        }}
                        icon={<RadioButtonUncheckedIcon />}
                        checkedIcon={<RadioButtonCheckedIcon />}
                        sx={{
                          color: primary,
                          "&.Mui-checked": {
                            color: primary,
                          },
                        }}
                      />
                    }
                    label={option}
                  />
                ))}
              </Box>
            </AccordionDetails>
          </Accordion>

          {/* Call Duration */}
          {/* {isFilter?.callDuration && ( */}

          {/* <Accordion
            disableGutters
            expanded={expandedAccordion === "callDuration"}
            onChange={() =>
              setExpandedAccordion(
                expandedAccordion === "callDuration" ? false : "callDuration"
              )
            }
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                border:
                  filterState?.filters?.callDuration?.length > 0
                    ? `2px solid ${primaryBg}`
                    : "1px solid transparent",
                backgroundColor:
                  filterState?.filters?.callDuration?.length > 0
                    ? "#E6F0FF"
                    : "inherit",
                borderRadius:
                  filterState?.filters?.callDuration?.length > 0 ? 2 : 0,
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
                <Typography>Call Duration</Typography>

                {filterState?.filters?.callDuration?.length > 0 && (
                  <Box
                    sx={{
                      backgroundColor: primary,
                      color: "white",
                      fontSize: 12,
                      fontWeight: "bold",
                      borderRadius: "12px",
                      px: 0.5,
                      py: 0.3,
                      minWidth: 15,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {filterState.filters.callDuration.length}
                  </Box>
                )}
              </Box>
            </AccordionSummary>

            <Divider />

            <AccordionDetails>
              {(() => {
                const callDurationRange =
                  filterState?.filters?.callDuration?.length
                    ? filterState.filters.callDuration
                    : [0, 60]; // minutes

                return (
                  <>
        
                    <Slider
                      // value={filterState?.filters?.callDuration?.length
                      //   ? filterState.filters.callDuration
                      //   : [0, 60] // default 0–1 hour
                      // }
                      value={tempCallDuration}
                      min={0}
                      max={60}
                      step={1}
                      valueLabelDisplay="auto"
                      // onChange={(e, newValue) =>
                      //   updateFilterArray("callDuration", newValue)
                      // }
                      onChange={(e, newValue) => {
                        setTempCallDuration(newValue);
                      }}

                      // 🔹 Fires once drag stops
                      onChangeCommitted={(e, newValue) => {
                        updateFilterArray("callDuration", newValue);
                      }}

                      sx={{
                        color: "#7635dd",
                        // main slider color
                        "& .MuiSlider-thumb": {
                          backgroundColor: "#7635dd",
                        },
                        "& .MuiSlider-track": {
                          backgroundColor: "#7635dd",
                        },
                        "& .MuiSlider-rail": {
                          opacity: 0.3,
                        },
                      }}
                    />

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mt: 1,
                      }}
                    >
                      <Typography variant="caption">
                        Min: {callDurationRange[0]} min
                      </Typography>
                      <Typography variant="caption">
                        Max: {callDurationRange[1]} min
                      </Typography>
                    </Box>
                  </>
                );
              })()}
            </AccordionDetails>
          </Accordion> */}


          {/* )} */}

          {/* call score */}

          {isFilter?.callScore && (
            <Accordion
              disableGutters
              expanded={expandedAccordion === "callScore"}
              onChange={() =>
                setExpandedAccordion(
                  expandedAccordion === "callScore" ? false : "callScore"
                )
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  border:
                    filterState?.filters?.callScore?.length > 0
                      ? `2px solid ${primaryBg}`
                      : "1px solid transparent",
                  backgroundColor:
                    filterState?.filters?.callScore?.length > 0
                      ? "#E6F0FF"
                      : "inherit",
                  borderRadius:
                    filterState?.filters?.callScore?.length > 0 ? 2 : 0,
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
                  <Typography>Call Score</Typography>

                  {filterState?.filters?.callScore?.length > 0 && (
                    <Box
                      sx={{
                        backgroundColor: primary,
                        color: "white",
                        fontSize: 10,
                        fontWeight: "bold",
                        borderRadius: "12px",
                        px: 0.5,
                        py: 0.3,
                        minWidth: 15,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {filterState.filters.callScore.length}
                    </Box>
                  )}
                </Box>
              </AccordionSummary>

              <Divider />

              <AccordionDetails>
                {/* ===== RANGE VALUE ===== */}
                {(() => {
                  const callScoreRange =
                    filterState?.filters?.callScore?.length
                      ? filterState.filters.callScore
                      : [0, 100];

                  return (
                    <>
                      {/* ===== SLIDER ===== */}
                      <Slider
                        // value={filterState?.filters?.callScore?.length
                        //   ? filterState.filters.callScore
                        //   : [0, 100] // default 0–1 hour
                        // }
                        value={tempCallScore}
                        min={0}
                        max={100}
                        step={1}
                        valueLabelDisplay="auto"
                        // onChange={(e, newValue) =>
                        //   updateFilterArray("callScore", newValue)
                        // }

                        onChange={(e, newValue) => {
                          setTempCallScore(newValue);
                        }}

                        // update filter ONLY when drag stops
                        onChangeCommitted={(e, newValue) => {
                          updateFilterArray("callScore", newValue);
                        }}
                        sx={{
                          color: "#7635dd",
                          // main slider color
                          "& .MuiSlider-thumb": {
                            backgroundColor: "#7635dd",
                          },
                          "& .MuiSlider-track": {
                            backgroundColor: "#7635dd",
                          },
                          "& .MuiSlider-rail": {
                            opacity: 0.3,
                          },
                        }}
                      />



                      {/* ===== RANGE TEXT ===== */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mt: 1,
                        }}
                      >
                        <Typography variant="caption">
                          Min: {callScoreRange[0]}
                        </Typography>
                        <Typography variant="caption">
                          Max: {callScoreRange[1]}
                        </Typography>
                      </Box>
                    </>
                  );
                })()}
              </AccordionDetails>
            </Accordion>
          )}

        </Popover>

        {/* clear */}
        <Box
          onClick={() => {
            const clearedFilters = {
              filters: {
                startDate: "",
                endDate: "",
                sentiment: [],
                status: "",
                agents: [],
                branchManagers: [],
                campaigns: [],
                callInteraction: "",
                callCompliance: "",
                callDuration: [],
                disposition: [],
                subDisposition: [],
                conversationStatus: [],
                categoryDistribution: [],
              },
              appliedFilters: [],
              frequentKeywords: "",
            };

            setFilterState(clearedFilters);

            localStorage.setItem(
              storageName,
              btoa(JSON.stringify(clearedFilters))
            );
          }}
          sx={{
            display: "flex",
            alignItems: "center",
            px: 2,
            py: 1,
            borderRadius: "12px",
            border: "1px solid #E0E0E0",
            transition: "background-color 0.2s, box-shadow 0.2s",
            "&:hover": {
              backgroundColor:
                filterState?.appliedFilters?.length > 0 ||
                  isAnyFilterApplied ||
                  isAnyDashboardFilterApplied
                  ? primary
                  : "#EEF2FF",
              boxShadow: "0px 1px 4px rgba(0,0,0,0.1)",
              color: "#fff",
            },
            "&:active": {
              boxShadow: "inset 0 2px 4px rgba(0,0,0,0.2)",
              backgroundColor: "#E0E7FF",
            },
            backgroundColor:
              filterState?.appliedFilters?.length > 0 ||
                isAnyFilterApplied ||
                isAnyDashboardFilterApplied
                ? primary
                : "#F9FAFB",
            boxShadow:
              filterState?.appliedFilters?.length > 0 ||
                isAnyFilterApplied ||
                isAnyDashboardFilterApplied
                ? "0px 1px 4px rgba(0,0,0,0.1)"
                : "0px 1px 1px 0px #D2D2D2",
            cursor:
              filterState?.appliedFilters?.length > 0 ||
                isAnyFilterApplied ||
                isAnyDashboardFilterApplied
                ? "pointer"
                : "default",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontWeight: 500,
              color:
                filterState?.appliedFilters?.length > 0 ||
                  isAnyFilterApplied ||
                  isAnyDashboardFilterApplied
                  ? "#fff"
                  : "#1E293B",
            }}
          >
            Clear
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CommonFilter;
